module.exports = __webpack_public_path__ + "static/img/Cladding_Cedar_Standard.a85c2fa.jpg";